import React, { useState, useEffect } from "react";
import { Trans } from "@lingui/macro";
import { withI18n } from "@lingui/react";
import { connect } from "react-redux";
import algoliasearch from "algoliasearch/lite";
import {
  InstantSearch,
  Configure,
  connectCurrentRefinements,
  SearchBox,
  ClearRefinements,
} from "react-instantsearch-dom";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../redux/actions/cart_actions";
import { getParameterByName, encodeQueryData } from "../../utils/app-helpers";
import MenuMobile from "./menuMobile";
import Pagination from "./pagination";
import Menu from "./menu";
import Hits from "./hits";
import { useBreakpoint } from "../../../breakpoint.js";
import LangRefinement from "./langRefinement";
import categoriesTranslations from "../../hooks/categoriesTranslations";
import navigate from "../navigate";

const algoliaClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID,
  process.env.GATSBY_ALGOLIA_SEARCH_KEY
);

const createURL = (state) => {
  const category = state.menu["permalink.category"];

  const categoryPath =
    category === "" || typeof category === "undefined" ? "" : `/${category}`;

  const queryParameters = {};

  if (state.query) {
    queryParameters.query = encodeURIComponent(state.query);
  }
  if (state.page !== 1) {
    queryParameters.page = state.page;
  }
  if (state.menu && state.menu.language) {
    queryParameters.language = state.menu.language;
  }

  const queryData = encodeQueryData(queryParameters);

  return `/courses${categoryPath}/${queryData}`;
};

const searchStateToUrl = (searchState, category) =>
  searchState ? createURL(searchState, category) : "";

const urlToSearchState = (category) => {
  const query = getParameterByName("query");
  const page = getParameterByName("page");
  const language = getParameterByName("language");

  return {
    query: query !== null ? decodeURIComponent(query) : "",
    page: page !== null ? page : 1,
    menu: {
      "permalink.category": typeof category !== "undefined" ? category : "",
      language: language,
    },
  };
};

const Default = (props) => {
  const i18n = props.i18n;
  // const prices = usePrices();

  const [menuIsVisible, setMenuIsVisible] = useState(false);
  const [searchState, setSearchState] = useState(
    urlToSearchState(props.pageContext.category)
  );
  const [category] = useState(props.category);

  const breakpoints = useBreakpoint();

  const onSearchStateChange = (updatedSearchState) => {
    if (
      (typeof updatedSearchState.menu["permalink.category"] !== "undefined" &&
        category != updatedSearchState.menu["permalink.category"] &&
        searchState.menu["permalink.category"] !==
          updatedSearchState.menu["permalink.category"]) ||
      searchState.page !== updatedSearchState.page ||
      searchState.menu["language"] !== updatedSearchState.menu["language"] ||
      searchState.query !== updatedSearchState.query
    ) {
      setSearchState(updatedSearchState);

      navigate(
        `${searchStateToUrl(
          updatedSearchState,
          updatedSearchState.menu["permalink.category"]
        )}`,
        i18n.language
      );
      return false;
    }
  };

  useEffect(() => {
    return () => {
      return false;
    };
  });

  return (
    <>
      <div className="p-2 sm:p-4">
        <div className="md:mr-auto md:ml-auto lg:max-w-6xl text-sm">
          <InstantSearch
            indexName={process.env.GATSBY_ALGOLIA_INDEX_NAME}
            searchClient={algoliaClient}
            searchState={searchState}
            onSearchStateChange={onSearchStateChange}
            createURL={createURL}
            refresh
          >
            <Configure
              hitsPerPage={breakpoints.sm ? 10 : breakpoints.md ? 8 : 9}
              query=""
            />
            <div className="mb-4 mt-2 md:mb-0 md:mt-4">
              <h3>
                <Trans>Course categories</Trans>
              </h3>
            </div>
            {/* just to make aviable the query search */}
            <SearchBox className="hidden" />
            {breakpoints.sm && (
              <>
                <div className="flex justify-between items-center mt-6">
                  <LangRefinement attribute="language" />
                  <button
                    onClick={() => setMenuIsVisible(true)}
                    className="btn btn-primary-reverse space-x-2 inline-flex items-center py-1 px-2 sm:px-4"
                  >
                    <span>
                      <Trans>Choose category</Trans>
                    </span>
                    <span className="icon-angle-down text-xl" />
                  </button>
                </div>
                <div className="text-center font-medium mt-2">
                  <CurrentRefinements
                    transformItems={(items) =>
                      items.filter((item) => item.attribute !== "language")
                    }
                  />
                </div>
              </>
            )}

            <div className="md:flex md:items-start">
              {breakpoints.sm ? (
                <MenuMobile
                  visible={menuIsVisible}
                  setMenuIsVisible={setMenuIsVisible}
                />
              ) : (
                <Menu />
              )}
              <div className="md:flex-1 xl:ml-6 pt-2 md:pt-0">
                <div className="items-center justify-between mb-4 hidden md:flex -mt-6">
                  <div className="text-base capitalize ml-2 xl:ml-6">
                    {searchState.query && (
                      <div className="flex items-center space-x-2">
                        <span>
                          <Trans>Searching for:</Trans>
                        </span>{" "}
                        <span className="font-semibold"> {searchState.query}</span>
                        <ClearRefinements
                          clearsQuery={true}
                          translations={{
                            reset: <div className="icon icon-times text-lg" />,
                          }}
                          title="Clear query"
                        />
                      </div>
                    )}
                    {props.pageContext.category && (
                      <div className="flex items-center space-x-2">
                        {" "}
                        <div>
                          <Trans>Courses</Trans>
                        </div>
                        <div className="text-xl leading-none">
                          <span className="icon-angle-right" />
                        </div>
                        <CurrentRefinements
                          transformItems={(items) =>
                            items.filter(
                              (item) => item.attribute !== "language"
                            )
                          }
                        />
                      </div>
                    )}
                  </div>
                  <LangRefinement attribute="language" />
                </div>
                {/* <PricesContext.Provider value={prices}> */}
                <Hits
                  {...{
                    products: props.cart.products,
                    removeFromCartAction: props.removeFromCartAction,
                    addToCartAction: props.addToCartAction,
                    locale: props.pageContext.locale,
                  }}
                />
                {/* </PricesContext.Provider> */}
                <Pagination padding={2} className="md:mt-6" showFirst={true} />
              </div>
            </div>
          </InstantSearch>
        </div>
      </div>
    </>
  );
};

const CurrentRefinements = connectCurrentRefinements(({ items }) => {
  return (
    <ul>
      {items.map((item) => {
        return (
          <li key={item.currentRefinement} className="capitalize font-medium">
            {categoriesTranslations(item.currentRefinement)}
          </li>
        );
      })}
    </ul>
  );
});

const mapStateToProps = ({ cart }) => {
  return {
    cart,
  };
};

const mapActionsToProps = (dispatch) => {
  return bindActionCreators(actionCreators, dispatch);
};

export default withI18n()(connect(mapStateToProps, mapActionsToProps)(Default));
